export default __webpack_public_path__ + "assets/amil-icon-component.eaf165fd.svg";